import api from './api'
import os from '@edu-fe/os'
import * as get from '@ccforeverd/tool-get'
import { login } from '@edu-fe/login'
import getOrderId from './get-order-id'
import { saveOrderId } from './utils'

// 打开
function open (url) {
  if (os.type === 'app' && os.name === 'wpsIos') {
    os.sdk.view.open(url)
  } else {
    if (os.name === 'loan' && os.system === 'ios') {
      window.jsBridge && window.jsBridge.goToNativePage(JSON.stringify({
        page: 'KSBaseUIWebViewController',
        urlString: url
      }))
    } else {
      window.location.href = url
    }
  }
}

/**
 * H5下单接口
 *
 * @param {Object} params 参数
 * @param {String} params.couponId 优惠券id
 * @param {String} params.courseId 商品id
 * @param {Number} params.type 商品类型, 1:课程 | 2:专题
 * @param {Number} params.payWay 下单方式, 9:支付宝 | 10:微信支付
 * @param {String} params.from 订单来源
 * @param {Number} params.isSend 是否是赠送, 1:是 | 0:不是
 * @param {Number} params.theme 赠送主题
 * @param {String} params.wpsSid 用户id
 * @param {String} params.returnUrl 返回地址(非encode值)
 * @return {Promise} 接口返回信息 { giftId }
 */
export default async function pay (params) {
  const { payWay } = params
  switch (parseInt(payWay)) {
    case 9: // 支付宝
      // 直接跳转页面
      params.returnUrl = encodeURIComponent(get.add(params.returnUrl, { fromAlipay: '1' })) // returnUrl在后台跳转时会加上orderId, 即 fromAlipay=1&orderId=xxx
      const alipayUrl = get.add('https://course.auoktalk.com/api/order/h5/', params)
      setTimeout(() => open(alipayUrl), 30)
      return {}

    case 10: // 微信
      // 接口返回url, 然后跳转页面
      console.log(params)
      const { code, data: wxpayUrl } = await api.PackageEduFePay.h5(params)

      console.log('wuyingbo ---')
      console.log(wxpayUrl)

      // 处理支付未登录 wuyingbo
      if (code < 0) {
        console.log('wuyingbo')
        // return login.then(() => pay(params))
      }

      console.log('-------------' + wxpayUrl)
      // const orderId = await getOrderId(params.courseId)
      const orderId = '111199998888'

      saveOrderId(orderId)
      setTimeout(() => open(wxpayUrl), 30)

      return { orderId }
  }
}
